// Dokument im Mieter- bzw. Eigentümerportal freigeben/verbergen. Admins und Team dürfen das (31.10.2026) – über
// die Datenbankfunktion setze_portal_freigabe, die nur die Portal-Häkchen ändert (kein allgemeines Änderungsrecht).
// Ist die Migration 2026-11-01-portal-freigabe-team noch nicht eingespielt, gilt der alte Weg (nur Admins).
import { supabase } from '../supabase/client';

export type Portal = 'mieter' | 'eigentuemer';

const SPALTE: Record<Portal, string> = { mieter: 'fuer_mieter_sichtbar', eigentuemer: 'fuer_eigentuemer_sichtbar' };
const NICHT_ERLAUBT = 'Dieses Dokument darfst du nicht freigeben.';

/** Liefert eine Fehlermeldung oder null. */
export async function setzePortalFreigabe(dokumentId: string, fuer: Portal, an: boolean): Promise<string | null> {
  const { data, error } = await supabase.rpc('setze_portal_freigabe', { p_dokument_id: dokumentId, p_fuer: fuer, p_an: an });
  if (!error) return data === true ? null : NICHT_ERLAUBT;
  if (error.code !== 'PGRST202') return error.message;
  const alt = await supabase.from('dokumente').update({ [SPALTE[fuer]]: an }).eq('id', dokumentId).select('id');
  if (alt.error) return alt.error.message;
  return alt.data?.length ? null : NICHT_ERLAUBT;
}
